import React from "react";
import { Button, CircularProgress } from "@mui/material";

const CommonButton = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  sx = {},
  size = "medium",
  ...rest
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      size={size}
      sx={{
        backgroundColor: "primary.main",
        color: "#fff",
        textTransform: "none",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "primary.dark",
        },
        borderRadius: "8px",
        gap:2,
        paddingX: 2,
        paddingY: 1,
        ...sx,
      }}
      {...rest}
    >
        {children}
    </Button>
  );
};

export default CommonButton;
